"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewSubmissionPayloadSchema = void 0;
exports.formPayloadToReviewSubmissionPayload = formPayloadToReviewSubmissionPayload;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const signal_name_normalization_1 = require("../DataScience/signal-hygiene/signal-name-normalization");
const misc_1 = require("../Wizard/Definitions/misc");
exports.ReviewSubmissionPayloadSchema = z
    .object({
    sigmaModelType: z.string(),
    signals: sigma_engine_shared_1.SignalSchema.array(),
    parameters: misc_1.pkgParametersSchema,
    pinout: misc_1.pkgPinoutSchema,
    boundaries: sigma_engine_shared_1.ComponentBoundarySchema.array(),
    resources: sigma_engine_shared_1.IComponentResourceSchema.array(),
    functions: sigma_engine_shared_1.IComponentFunctionSchema.array(),
    modes: sigma_engine_shared_1.ModeBaseSchema.array(),
    spiceModels: sigma_engine_shared_1.SPICE.ISubModelOptsSchema.array(),
})
    .superRefine((payload, ctx) => {
    const seen = new Set();
    payload.signals.forEach((signal, index) => {
        const nameKey = (0, signal_name_normalization_1.normalizeSignalNameForComparison)(signal.name);
        if (seen.has(nameKey)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Duplicate signal name: "${signal.name}"`,
                path: ['signals', index, 'name'],
            });
            return;
        }
        seen.add(nameKey);
    });
});
function formPayloadToReviewSubmissionPayload(form) {
    return {
        sigmaModelType: form.sigmaModelType,
        signals: form.signals,
        parameters: form.parameters,
        pinout: form.pinout,
        boundaries: form.boundaries ?? [],
        resources: [],
        functions: [],
        modes: [],
        spiceModels: form.spiceModels,
    };
}
//# sourceMappingURL=review-submission-payload.js.map